import React, { useEffect, useRef, useState } from "react";
import apiService from "../../APIService";
// import jsPDF from "jspdf";

import MessageA1 from "./MessageA1";
import MessageA1Live from "./MessageA1Live";
import MessageA3 from "./MessageA3";
import MessageA4 from "./MessageA4";
import MessageA3F from "./MessageA3F";
import MessageA7 from "./MessageA7";
import MessageA13 from "./MessageA13";
import MessageA14 from "./MessageA14";
import MessageA15 from "./MessageA15";
import MessageA19 from "./MessageA19";
import MessageA20 from "./MessageA20";
import MessageA21 from "./MessageA21";
import MessageA22 from "./MessageA22";
import MessageA23 from "./MessageA23";
import MessageA24 from "./MessageA24";

import MessageA14C from "./MessageA14c";

import MessageRedirect from "./MessageRedirect";

import secureLocalStorage from "react-secure-storage";

import "../../HelpAssistant/HelpAssistant.css";
import MessageA13s from "./MessageA13s";
import MessageA1i from "./MessageA1i";
import VideoMessage from "./VideoMessage";
import MessageA14s from "./MessageA14s";
import TickIcon from "../../../../src/images/oriserve/images/TickIcon.svg";
import MessageA23B from "./MessageA23B";
import MessageA23A from "./MessageA23A";
import MessageA81 from "./MessageA81";
import { getDelayInMs } from "../../Methods/Method";
import MessageA3s from "./MessageA3s";
import MessageA3SeeMore from "./MessageA3SeeMore";

import { DisableUI } from "../Utils/Toast/Method";
// import A1IMG from "./A1IMG";
import A1DeviceSwitch from "./A1DeviceSwitch";
import A1DeviceLimit from "./A1DeviceLimit";
import A1DeviceLimitList from "./A1DeviceLimitList";
import WC26TABLE from "./WC26TABLE";
import CustomDatePicker from "../../FormFields/CustomDatePicker";


var isIdleMsg = true;
const tableUiCommands = [ "WC26TABLE_V1", "A1DeviceLimitList"];
const isTableResponse = (group = []) =>
  group.some((item) => tableUiCommands.includes(item?.uiCommand));

const Conversation = (props) => {
  const { 
    onMenuButtonClick,
    setOnMenuButtonClick,
    setShowErrorPopUp,
    showErrorPopUp,
    setEnableAttachment,
    isAttachementDisable,
    setAttachementImg,
    setCodeValue,
    setGenesisUrl,
    setShowIframe,
    iframeRef,
    setLitmusFeedback,
    delayTime,
    setDelayTime,
    setCTAView ,
    CTAView,
    sessionHistory,
    setSessionHistory,
   } = props

  const timeCurrent =
    new Date().toLocaleTimeString("en-us").split(":")[0] +
    ":" +
    new Date().toLocaleTimeString("en-us").split(":")[1] +
    " " +
    new Date().toLocaleTimeString("en-us").substr(-2);

  let [currentData, setCurrentData] = useState([]);
  const [messages, setMessages] = useState([]);
  const [initalState, setInitalState] = useState([]);
  const [textOnClick, setTextOnClick] = useState();
  const [showBanner, setShowBanner] = useState(false);
  const [bannerData, setBannerData] = useState();
  const [showRecharge, setShowRecharge] = useState(false);
  const [rechargeData, setRechargeData] = useState();
  const [historyData, setHistoryData] = useState();
  const [showHistory, setShowHistory] = useState(props.showHistory);
  const [isLoading, setIsLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(false);
  const [auth, setAuth] = useState(props.auth);
  const [enableTextBox, setEnableTextBox] = useState(false);
  const[feedBackIndex ,setFeedBackIndex] =useState(0);
  const [showDelayLoader, setShowDelayLoader] = useState(false);

  const messagesEndRef = useRef(null);


  const [chatEnd, setChatEnd] = useState(false);
  const [finalTimerFlag, setFinalTimerFlag] = useState(false);
  const [subTextOnClick, setSubTextOnClick] = useState();
  const [chatWithAgentClicked, setChatWithAgentClicked] = useState(false);

  //selected arry of historychat
  const [selectionArray , setSelectionArray] = useState([])
  const [disableButtons , setDisableButtons] = useState(false)

  let idleTimer;
  let secondIdleTimer;
  let finalTimer;

  const [idleTime, setIdleTime] = useState(0);

  const inputValue = useRef(null);
  useEffect(() => {
    const encodedUser = encodeURIComponent(props?.userDetails)
    !sessionHistory && apiService.fetchDataHistoryData(encodedUser)
      .then((response) => {
        const data = response?.data?.history?.history;
        
        const historyMessages = data?.flatMap(session => {
          let msgs = [];
          if (session.userResponse) {
            msgs.push({ type: "user", data: session.userResponse });
          }
          if (session.botResponse?.entries?.length) {
            msgs.push({ type: "bot", data: session.botResponse.entries });
          }
          return msgs;
        });
        setDisableButtons(true)
        setSessionHistory(data);
      });
}, []);

  useEffect(()=>{
    if(onMenuButtonClick){
      handleClick(null, null, "Menu")
      setOnMenuButtonClick(false)
      setTextOnClick("Menu")
    }
  },[onMenuButtonClick])

  useEffect(() => {
    let isFinalTimerTriggered = false;

    const handleUserActivity = () => {
      clearTimeout(idleTimer);
      clearTimeout(secondIdleTimer);

      if (!chatEnd) {
        setIdleTime(0);
      }

      if (!chatEnd && !isFinalTimerTriggered) {
        clearTimeout(finalTimer);

        const showIdleTime = sessionStorage.getItem("showIdleTime");
      if(!showIdleTime){ 
         idleTimer = setTimeout(() => {
          setIdleTime(idleTime + 1);
          let initialArray = [];
          initialArray.push({
            uiCommand: "idle",
            text: "Hey there! We're eagerly waiting for you & we'd love to help you with your query.",
          });
          sessionStorage.setItem("showIdleTime", "true"); // save string
          setCurrentData(initialArray);
        }, 30 * 1000);
      }
        finalTimer = setTimeout(() => {
          apiService.userActivity("3").then((res) => {
            console.log(res);
          });
          setIdleTime(idleTime + 1);
          props.setIsSessionExpired(true);
          isFinalTimerTriggered = true;
          setFinalTimerFlag(true);
          props.setShowIdlePopup(true);
          props.setIsClearChatModal(false);
        }, 30 * 60 * 1000);
      }
    };

    const resetIdleTimer = () => {
      handleUserActivity();
    };

    if (!finalTimerFlag && !chatEnd && !props.isChatWithUs) {
      window.addEventListener("click", resetIdleTimer);
    }

    if (chatEnd) {
      clearTimeout(idleTimer);
      clearTimeout(finalTimer);
    }

    return () => {
      clearTimeout(idleTimer);
      clearTimeout(finalTimer);
    };
  }, [isIdleMsg]);

  useEffect(() => {
    if (finalTimerFlag) {
      let n = document.getElementsByClassName("action-tab");

      for (let i = 0; i < n.length; i++) {
        n[i].disabled = true;
        n[i].style.cursor = "not-allowed";
      }
    }
  }, [finalTimerFlag]);

  window.s360BannerCallback = (code) => {
    handleClick(code);
    if (code === "1.6.1.1.1.12.13.17") setTextOnClick("Register Now");
    else if (code === "1.6.1.1.1.12.13.17.1.1") setTextOnClick("Done");
  };

  useEffect(() => {
    setAuth(props.auth);
  }, [props.auth]);

  useEffect(() => {
    if (currentData?.length === 0) {
      setCurrentData(props.chatData);
    }
  }, [props.chatData, currentData]);

  const scrollToBottom = () => {
    messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
  };

  //new addition 1
  useEffect(() => {
    setCurrentData(props.currentData);
  }, [props.currentData]);

  //
  useEffect(() => {
    if (props.login && !props.outSideLink && !props.action) {
      setInitialLoading(true);
      apiService.initialState().then((response) => {
        const data =
          response.data &&
          response.data.chatResponse &&
          response.data.chatResponse.entries;

        // props.handleInputBox(response.data.chatResponse.enableDefaultTextBox);

        setInitialLoading(false);
        data &&
          data.map((i) => {
            if (i.uiCommand === "A41") {
              setShowBanner(true);
              setBannerData(i);
            }
            if (i.uiCommand === "A40") {
              setShowRecharge(true);
              setRechargeData(i);
            }
          });
        setCurrentData(data);
        data &&
          data.map((item, index) => item.code && initalState.push(item.code));
      });
    }
  }, [props.login]);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const redirectClick = async (code, input, tag) => {
    let response;
    try {
      response = await apiService.chatPostPacks(code, input);

      setIsLoading(false);
      const data =
        response.data &&
        response.data.chatResponse &&
        response.data.chatResponse.entries;

      if (data) {
        data.forEach((el) => {
          if (
            el.text === "Thank you for contacting Tata Play. Happy viewing!"
          ) {
            isIdleMsg = false;
          } else {
            isIdleMsg = true;
          }
        });
      }
    } catch (error) {
      console.error("Error occurred:", error);
    } finally {
      setTextOnClick("");
    }
  };

  // const fetchConversationDetails = async (sessionId) => {
  //   try {
  //     const res = await apiService.getConversationDetails(sessionId);
  //     return res.data.data;
  //   } catch (error) {
  //     console.error("fetchConversationDetails error:", error);
  //   }
  // };

  // const generatePDF = (conversations) => {
  //   const doc = new jsPDF();
  //   let y = 10; // initial y position
  //   const marginBottom = 20; // bottom margin
  const delayTimerRef = useRef(null); // At the top of your component

  const handleDelayData = (data) => {
    if (delayTimerRef.current) {
      clearTimeout(delayTimerRef.current);
      delayTimerRef.current = null;
    }
  
    // Check if there's any A1break with Delay
    let hasDelay = false;
    data?.forEach(item => {
      if (item?.uiCommand === "A1break" && item?.text === "Delay") {
        hasDelay = true;
      }
    });

    if (!hasDelay) {
      setCurrentData(data);
      setShowDelayLoader(false);
      return;
    }

    const delayIndex = data?.findIndex(
      item => item?.uiCommand === "A1break" && item?.text === "Delay"
    );
  
    if (delayIndex === -1) {
      setCurrentData(data);
      setShowDelayLoader(false);
    } else {
      const delayItem = data[delayIndex];
      const delayTime = delayItem?.data ? getDelayInMs(delayItem.data) : 3000;
      const beforeDelay = data.slice(0, delayIndex);
      const afterDelay = data.slice(delayIndex + 1);
  
      setCurrentData(beforeDelay);
      setShowDelayLoader(true);
  
      delayTimerRef.current = setTimeout(() => {
        setShowDelayLoader(false);
        handleDelayData(afterDelay);
        delayTimerRef.current = null;
      }, delayTime);
    }
  };

  
  // const generatePDF = (conversations) => {
  //   const doc = new jsPDF();
  //   let y = 10; // initial y position
  //   const marginBottom = 20; // bottom margin

  //   conversations.forEach((chat) => {
  //     if (!chat) return; // Ensure chat is not null or undefined

  //     doc.text(10, y, `Time: ${chat.time}`);
  //     y += 10;

  //     let isFirstBotMessage = true;

  //     chat.botResponse.entries.forEach((entry) => {
  //       if (!entry) return; // Ensure entry is not null or undefined

  //       const textToAdd = isFirstBotMessage ? `Bot: ${entry.text}` : entry.text;
  //       const splitText = doc.splitTextToSize(textToAdd, 180);

  //       if (
  //         y + splitText.length * 10 >
  //         doc.internal.pageSize.height - marginBottom
  //       ) {
  //         doc.addPage();
  //         y = 10;
  //       }

  //       doc.text(10, y, splitText);
  //       if (isFirstBotMessage) isFirstBotMessage = false;
  //       y += splitText.length * 10;
  //     });

  //     if (chat.userResponse) {
  //       const userResponseText = `User: ${chat.userResponse.text}`;
  //       const splitUserResponse = doc.splitTextToSize(userResponseText, 180);

  //       if (
  //         y + splitUserResponse.length * 10 >
  //         doc.internal.pageSize.height - marginBottom
  //       ) {
  //         doc.addPage();
  //         y = 10;
  //       }

  //       doc.text(10, y, splitUserResponse);
  //       y += splitUserResponse.length * 10;
  //     }

  //     y += 10; // add some space before the next chat block
  //   });

  //   return doc.output("blob");
  // };

  // const uploadConversationPDF = async (sessionId, pdfBlob) => {
  //   try {
  //     const formData = new FormData();
  //     formData.append("file", pdfBlob, "conversation.pdf");
  //     formData.append("sessionId", sessionId);
  //     formData.append("bot", "oriserve");

  //     const response = await apiService.uploadConversationMedia(
  //       formData,
  //       sessionId
  //     );
  //     if (response.data.code !== 200) throw new Error("File upload failed");
  //     return response.data;
  //   } catch (error) {
  //     console.error("uploadConversationPDF error:", error);
  //   }
  // };

  // const fetchUserActivity = async () => {
  //   try {
  //     const res = await apiService.userActivity("1");
  //     const { code, sessionId } = res.data;
  //     if (code !== 200 || !sessionId) throw new Error("Invalid response");
  //     return sessionId;
  //   } catch (error) {
  //     console.error("fetchUserActivity error:", error);
  //   }
  // };

  const handleClick = async (code, input, label, tag) => {
    props.setHideFooter(false);
    props.setCTAView(false)
    setSubTextOnClick('')
    setAttachementImg(isAttachementDisable)
    setEnableAttachment(false)
    // props.setCodeValue(code)
    clearTimeout(idleTimer);
    clearTimeout(secondIdleTimer);
    clearTimeout(finalTimer);

    setIsLoading(true);

    let n = document.getElementsByClassName("action-tab");

    for (let i = 0; i < n.length; i++) {
      n[i].disabled = true;
      n[i].style.cursor = "not-allowed";
      // n[i].style.opacity = 0.5;
      n[i].style.pointerEvents = "none";
    }

    let inputs = document.getElementsByClassName("form-control");

    for (let i = 0; i < inputs?.length; i++) {
      inputs[i].style.cursor = "not-allowed"; // Set cursor style
      inputs[i].disabled = true; // Disable input elements
      // Optional styles if needed:
      // elements[i].style.opacity = "0.5";
      // elements[i].style.pointerEvents = "none";
    }

    let  dropdown = document.getElementsByClassName("dropdown-container");

    for (let i = 0; i < dropdown?.length; i++) {
      dropdown[i].style.cursor = "not-allowed"; // Set cursor style
      dropdown[i].disabled = true; // Disable input elements
      // Optional styles if needed:
      // dropdown[i].style.opacity = "0.5";
      dropdown[i].style.pointerEvents = "none";
    }

    let button = document.getElementsByClassName("action-button");

    for (let i = 0; i < button?.length; i++) {
      let btn = button[i];
      let computedColor = window.getComputedStyle(btn).color;
    
      if (computedColor !== "rgb(142, 129, 161)") {
        btn.style.color = "rgba(142, 129, 161, 1)";
      }
    
      btn.style.border = "1px solid rgba(142, 129, 161, 1)";
      
      if (!btn.classList.contains("selected")) {
        btn.style.backgroundColor = "transparent";
      }
    }
    

    let submitButton = document.getElementsByClassName("submit-button-action");

    for (let i = 0; i < submitButton?.length; i++) {
      let computedColor = window.getComputedStyle(submitButton[i]).color; // Get the computed color
      if(computedColor != "rgb(142, 129, 161)"){
        submitButton[i].style.color = "rgba(142, 129, 161, 1)"; // Set cursor style
      }
      submitButton[i].style.border = '1px solid rgba(142, 129, 161, 1)'; // Disable input elements
    }

    const buttons = document.querySelectorAll(".disable-tooltips");

    buttons.forEach(btn => {
      if (btn.classList.contains("disable-tooltips")) {
        btn.style.cursor = "not-allowed"; // Set cursor style
        btn.style.disabled = true; // Disable input elements
        btn.style.pointerEvents = "none";
        btn.classList.add("no-tooltip");
      }
    }); 
   

    
    

    const typingTimeout = setTimeout(() => {
      props.setDelayBotResponse(true);
    }, 1000);

    let response;

    try {
      if (tag === "A58") {
        response = await apiService.chatPost(code, input);
      } else if (tag === "A59" || tag === "A63") {
        response = await apiService.chatPostPacks(code, input);
      } else {
        response = await apiService.chat(code, input, label);
      }
  
      setCodeValue(null)
      clearTimeout(typingTimeout); // Clear the typing timeout if API response received
      props.setDelayBotResponse(false);

      setIsLoading(false);
      const data =
        response.data &&
        response.data.chatResponse &&
        response.data.chatResponse.entries;
        props.setFlow(response?.data?.chatResponse?.flow)
        props.setCTAView(response?.data?.chatResponse?.enableVertical)
      if (response?.data?.chatResponse?.end) {
        props.setDisabledEntryIcons(true);
        // setTimeout(async () => {
        //   try {
        //     const sessionId = await fetchUserActivity();
        //     const conversationDetails = await fetchConversationDetails(sessionId);
        //     const pdfBlob = generatePDF(conversationDetails);
        //     await uploadConversationPDF(sessionId, pdfBlob);


        //   } catch (error) {
        //     console.error("handleConfirm error:", error);
        //   }
        // }, 1000);

        setTimeout(() => {

          if (
            response?.data?.chatResponse?.mapper !== 'CWE' &&
            response?.data?.chatResponse?.mapper !== 'FEEDBACK'
          ) {
            window.parent.postMessage({ endChatURL: "true" }, "*");
          }
          apiService.userActivity("4").then((res) => {
            console.log(res);
          });
        }, 3000);
      }

      // props.handleInputBox(response?.data?.chatResponse?.enableDefaultTextBox);

      if (response?.data?.chatResponse?.end === true && !chatEnd) {
        setChatEnd((val) => !val);
      }
      handleDelayData(data)
      // setEnableTextBox(response?.data?.chatResponse?.enableDefaultTextBox);

      if(response?.data?.chatResponse?.enableDefaultTextBox){
        props.setHideFooter(true);
      }
      if (data) {
        data.forEach((el) => {
          if (
            el.text === "Thank you for contacting Tata Play. Happy viewing!"
          ) {
            isIdleMsg = false;
          } else {
            isIdleMsg = true;
          }
        });
      }

      if ( data?.some((el) => el?.uiCommand === "A13s" || el?.uiCommand === "A13"  )) {
        props.setHideFooter(true);
      }
      if (
        data &&
        data.some((el) => el?.uiCommand === "A1" && el.text.includes("Yes"))
      ) {
        props.setHideFooter(true);
      }
    } catch (error) {
      console.error("Error occurred:", error);
    } finally {
      setTextOnClick("");
    }
  };

  useEffect(() => {
    let n = document.getElementsByClassName("action-tab");

    for (let i = 0; i < n.length; i++) {
      n[i].disabled = true;
      n[i].style.cursor = "not-allowed";
      n[i].style.opacity = 0.5;
      n[i].style.pointerEvents = "none";
    }

    if (props.textMessage.key1) {
      let data = {
        data: "John",
        uiCommand: "A7",
        text: props.textMessage.key1,
      };
      props.setMergeUI(true);
      props?.setCTAView(false)
      setCurrentData([data]);

      if (
        props.textMessage.dontSend === undefined &&
        props.textMessage !== ""
      ) {
        apiService.chat(props?.codeValue || null, props.textMessage).then((response) => {
          setIsLoading(false);
          setCodeValue(null)
          props.setCTAView(response?.data?.chatResponse?.enableVertical)
          const data =
            response.data &&
            response.data.chatResponse &&
            response.data.chatResponse.entries;
          // props.handleInputBox(
          //   response?.data?.chatResponse?.enableDefaultTextBox
          // );
        // setFlowName(response?.data?.chatResponse?.flow)
         props.setFlow(response?.data?.chatResponse?.flow)
          if (data) {
            data.forEach((el) => {
              if (
                el.text === "Thank you for contacting Tata Play. Happy viewing!"
              ) {
                isIdleMsg = false;
              } else {
                isIdleMsg = true;
              }
            });
          }
          // setCurrentData(data);
          handleDelayData(data)
          if(response?.data?.chatResponse?.enableDefaultTextBox){
            props.setHideFooter(true);
          }
          // setEnableTextBox(response?.data?.chatResponse?.enableDefaultTextBox);

          var parsedData = null;
          if (data[2] !== undefined && data[2].uiCommand === "A58") {
            parsedData = JSON.parse(JSON.stringify(data[2])).text_data;
            let temp = new Object();
            temp["selectedLanguages"] =
              parsedData?.filter?.language?.selectedLanguages;
            temp["selectedGenre"] = parsedData?.filter?.genre.selectedGenre;

            localStorage.setItem(
              "selectedLanguagesAndGenresTemp",
              JSON.stringify(temp)
            );
          }
        });
      }
    }
    setTextOnClick();
  }, [props.textMessage]);
  
  useEffect(() => {
    if (!sessionHistory || sessionHistory.length === 0) return;
  
    const historyMessages = sessionHistory?.flatMap((session ,index) => {
      const botEntries = session?.botResponse?.entries || [];
      const userText = session?.userInputObj?.key1 || session?.userResponse?.text ;
      const userSelection =  session?.userResponse?.text ? session?.userResponse?.text : "null"
      if (userSelection) {
        // Use functional update to append without overwriting previous values
        setSelectionArray(prev => [...prev, {index:index , selection : userSelection}]);
      }
      console.log(userSelection)
      const msgs = [];
  

      if (botEntries.length > 0) {
        msgs.push(
          <div className={`${index}`} key={`bot-${session?.id}`}>
            {botSessionHistory(botEntries ,session?.createdAt )} 
          </div>
        );
      }
  

      if (userText) {
        msgs.push(
          <div  key={`user-${session?.id}`}>
            {userSessionHistory(userText ,session?.createdAt )}
          </div>
        );
      }
  
      return msgs;
    });

  
   
    setMessages((prevMessages) => [...prevMessages, ...historyMessages , <div className="new-chat">New Chat</div>]);


  

  }, [sessionHistory]);
  
  
  

  //  Create a helper function outside your component or inside (before useEffect)
    const  userSessionHistory = (textOnClick , time) => {
      const isImage =
        textOnClick.includes("http://localhost:3000/") ||
        textOnClick.includes("https://d2w1s20s54h788.cloudfront.net/") ||
        textOnClick.includes("https://unifiedbotchat.tataplay.com/");

      return (
        <div className="onclick-openwrapp section0 userchatmsg0_1 userchatmsg">
          <div
            className="onclick-inner"
            style={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "flex-end",
              marginTop: 7,
            }}
          >
            <div className="send-text-wrap">
              {isImage ? (
                <img
                  style={{ width: "160px", cursor: "pointer" }}
                  src={textOnClick}
                  alt="click"
                  // onClick={() => setIsFullScreen({ show: true, src: textOnClick })}
                />
              ) : (
                <span
                  className="packs-text"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    textAlign: "left",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      width: "100%",
                      fontFamily: "'VoltePlay-Medium', sans-serif",
                      fontWeight: "500",
                      justifyContent: "end",
                    }}
                  >
                    {textOnClick}
                  </div>
                </span>
              )}

              <div style={{ display: "flex", alignItems: "center" }}>
                <div className="delivery-time-first" style={{ justifyContent: "end" }}>
                  {time}
                  <span style={{ marginLeft: "4px", marginTop: "4px" }}>
                    <img src={TickIcon} alt="tick" />
                  </span>
                </div>
              </div>

              <svg className="chat-tail" width="10" height="15" viewBox="0 0 10 10">
                <polygon points="0,0 20,0 10,10" fill="rgba(214, 198, 244, 1)" />
              </svg>
            </div>
          </div>
        </div>
      );
    }

  // history 
  const botSessionHistory = (sessionData ,time) => {
    function splitByA1Break(data) {
      const segments = [];
      let currentSegment = [];
  
      data.forEach((item) => {
        if (item.uiCommand === "A1break") {
          if (currentSegment.length > 0) {
            segments.push(currentSegment);
            currentSegment = [];
          }
        } else {
          currentSegment.push(item);
        }
      });
  
      if (currentSegment.length > 0) {
        segments.push(currentSegment);
      }
  
      return segments;
    }
  
    let dataObj = {};
    dataObj.isA3F = sessionData?.some(item => item.uiCommand === "A3f");
  
    // Only JSX is returned, no setMessages here
    const data =
      sessionData &&
      sessionData.length > 0 &&
      sessionData[0]?.uiCommand !== "idle" ? (
        <>
          {splitByA1Break(sessionData).map((group, groupIndex) => (
            <div
              key={groupIndex}
              style={{ 
                marginTop: groupIndex !== 0 ? "16px" : "16px"
              }}
              className={
                props.mergeUI && textOnClick === undefined
                  ? group[0]?.uiCommand === "A7"
                    ? ""
                    : "mergeConversation"
                  : isTableResponse(group)
                  ? "no-wrap-table"
                  : "no-wrap"
              }
            >
              {messageContent(group, dataObj)}
  
              {!dataObj?.isA3F && (
                <div
                  className="A1-container"
                  style={{ display: props?.CTAView && 'flow' }}
                >
                  {group.map((item, index) => (
                    <>
                      {item.uiCommand === "A1" && (
                        <MessageA1
                          item={item}
                          handleClick={handleClick}
                          setTextOnClick={setTextOnClick}
                          index={index}
                          setSubTextOnClick={setSubTextOnClick}
                          setGenesisUrl={setGenesisUrl}
                          setShowIframe={setShowIframe}
                          iframeRef={iframeRef}
                          disable={disableButtons}
                          setChatWithAgentClicked={setChatWithAgentClicked}
                        />
                      )}
                      {item.uiCommand === "A1live" && (
                        <MessageA1Live
                          item={item}
                          handleClick={handleClick}
                          setTextOnClick={setTextOnClick}
                          index={index}
                          setSubTextOnClick={setSubTextOnClick}
                          setGenesisUrl={setGenesisUrl}
                          setShowIframe={setShowIframe}
                          iframeRef={iframeRef}
                          setChatWithAgentClicked={setChatWithAgentClicked}
                          chatWithAgentClicked={chatWithAgentClicked}
                        />
                      )}
                      {item.uiCommand === "A21i" && (
                        <MessageA21
                          item={item}
                          handleClick={handleClick}
                          setTextOnClick={setTextOnClick}
                          index={index}
                          setSubTextOnClick={setSubTextOnClick}
                          setEnableAttachment={setEnableAttachment}
                          setAttachementImg={setAttachementImg}
                          {...props}
                        />
                      )}
                      {item.uiCommand === "Redirect" && (
                        <MessageRedirect
                          item={item}
                          handleClick={handleClick}
                          setTextOnClick={setTextOnClick}
                          redirectClick={redirectClick}
                        />
                      )}
                    </>
                  ))}
                </div>
              )}
  
              <div style={{ marginLeft: "2%" }}>
                {group.length > 0 && group[0].uiCommand !== "A7" && (
                  <div className="delivery-time-first">
                    {time}
                    <span style={{ marginLeft: '4px', marginTop: '4px' }}>
                      <img src={TickIcon} alt="tick" />
                    </span>
                  </div>
                )}
              </div>
            </div>
          ))}
  
          {dataObj?.isA3F && (
            <div style={{ display: "flex" }}>
              <div
                className={
                  props.mergeUI && textOnClick === undefined
                    ? `clickWrap`
                    : "no-wrap"
                }
              >
                {sessionData.map((item, index) => (
                  <div style={{ width: "100%" }} key={index}>
                    {item.uiCommand === "A3f" && (
                      <div className="A3-container">
                        <MessageA3F
                          item={item}
                          handleClick={handleClick}
                          setTextOnClick={setTextOnClick}
                        />
                      </div>
                    )}
                  </div>
                ))}
  
                <div
                  style={{ marginBottom: "10px", gap: "12px" }}
                  className="A23-container"
                >
                  {sessionData?.map((item, index) => {
                    if (item?.text === "Thumbs Up") {
                      setFeedBackIndex((prevIndex) => prevIndex + 1);
                    }
                    return (
                      <>
                        {item.uiCommand === "A23" && (
                          <div key={index} className="A23-container">
                            <MessageA23
                              item={item}
                              handleClick={handleClick}
                              setTextOnClick={setTextOnClick}
                              inputValue={inputValue}
                              index={feedBackIndex}
                            />
                          </div>
                        )}
                      </>
                    );
                  })}
                </div>
  
                <div
                  className="A1-container"
                  style={{ display: props?.CTAView && 'flow' }}
                >
                  {sessionData.map((item, index) => (
                    <>
                      {item.uiCommand === "A1" && (
                        <MessageA1
                          item={item}
                          handleClick={handleClick}
                          setTextOnClick={setTextOnClick}
                          setSubTextOnClick={setSubTextOnClick}
                          setGenesisUrl={setGenesisUrl}
                          setShowIframe={setShowIframe}
                          iframeRef={iframeRef}
                          disable={disableButtons}
                          setChatWithAgentClicked={setChatWithAgentClicked}
                        />
                      )}
                      {item.uiCommand === "A1live" && (
                        <MessageA1Live
                          item={item}
                          handleClick={handleClick}
                          setTextOnClick={setTextOnClick}
                          setSubTextOnClick={setSubTextOnClick}
                          setGenesisUrl={setGenesisUrl}
                          setShowIframe={setShowIframe}
                          iframeRef={iframeRef}
                          setChatWithAgentClicked={setChatWithAgentClicked}
                          chatWithAgentClicked={chatWithAgentClicked}
                        />
                      )}
                      {item.uiCommand === "A13s" && (
                        <MessageA13s item={item} inputValue={inputValue} />
                      )}
                      {item.uiCommand === "A15" && (
                        <MessageA15
                          item={item}
                          handleClick={handleClick}
                          setTextOnClick={setTextOnClick}
                          disabled={true}
                          inputValue={inputValue}
                        />
                      )}
                      {item.uiCommand === "Redirect" && (
                        <MessageRedirect
                          item={item}
                          handleClick={handleClick}
                          setTextOnClick={setTextOnClick}
                          redirectClick={redirectClick}
                        />
                      )}
                    </>
                  ))}
                </div>
  
                <div style={{ marginLeft: "2%" }}>
                  {sessionData.length > 0 &&
                    sessionData[0].uiCommand !== "A7" && (
                      <div className="delivery-time-first">{timeCurrent}
                        <span style={{ marginLeft: '4px', display: 'flex', alignItems: 'center' }}>
                          <img src={TickIcon} alt="tick" />
                        </span>
                      </div>
                    )}
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        sessionData &&
        !finalTimerFlag &&
        sessionData.map((item, index) => (
          <div style={{ width: "100%", display: "flex" }} key={index}>
            {item.uiCommand === "idle" && (
              <div className="idle-wrap">
                <p className="idle-wrap-text volte-text" style={{ margin: 0 }}>
                  {item?.createdAt}
                </p>
                <div style={{ fontSize: 10, color: "#abaeb2", marginTop: 4 }}>
                  {timeCurrent}
                </div>
              </div>
            )}
          </div>
        ))
      );
  
    return data; //  only return JSX
  };
  


  useEffect(() => {
    let data;
    if (textOnClick) {
      const isImage =
        textOnClick.includes("http://localhost:3000/") ||
        textOnClick.includes("https://d2w1s20s54h788.cloudfront.net/") ||
        textOnClick.includes("https://unifiedbotchat.tataplay.com/");

      data = (
        <div className="onclick-openwrapp section0 userchatmsg0_1 userchatmsg">
          <div
            className="onclick-inner"
            style={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "flex-end",
              marginTop: 7,
            }}
          >
            <div className="send-text-wrap">
              {isImage ? (
                <>
                  <img
                    style={{ width: "160px", cursor: "pointer" }}
                    src={textOnClick}
                    alt="click"
                    onClick={() => props?.setIsFullScreen({ show: true, src: textOnClick })}
                  />

                </>
              ) : (
                  <span className="packs-text" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", textAlign: "left" }}>
                    <div   style={{
                          display: "flex",
                          alignItems: "flex-start",
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          width: "100%",
                          fontFamily: "'VoltePlay-Medium', sans-serif",
                          fontWeight:'500',
                          justifyContent : 'end'
                        }}>
                      {textOnClick}
                    </div>
                  </span>

              )}

              <div style={{ display: "flex", alignItems: "center" }}>
                <div className="delivery-time-first" style={{justifyContent : 'end'}}>
                  {timeCurrent}
                  <span style={{marginLeft : '4px' , marginTop : '4px'}} >
                    {/* <svg
                      fill="currentColor"
                      preserveAspectRatio="xMidYMid meet"
                      height="13"
                      width="13"
                      viewBox="0 0 40 40"
                      class="ori-lr-mrgn-3"
                    >
                      <g>
                        <path d="m14.5 26.6l18-18 2.5 2.4-20.5 20.4-9.5-9.5 2.5-2.4z"></path>
                      </g>
                    </svg> */}
                    <img
                    // style={{ width: "160px", cursor: "pointer" }}
                    src={TickIcon}
                    alt="tick"
                  />
                  </span>
                </div>
              </div>
         
              <svg class="chat-tail" width="10" height="15" viewBox="0 0 10 10">
                <polygon points="0,0 20,0 10,10" fill="rgba(214, 198, 244, 1)" />
              </svg>
            </div>
          </div>
        </div>
      );
    }
    if (data) {
      setMessages([...messages, data]);
    }
  }, [textOnClick]);

  const messageContent = (data, dataObj) => {
    let messageComponents = [];

    for (let index = 0; index < data.length; index++) {
      const item = data[index];
      if (item?.uiCommand == "A3f") {
        dataObj.isA3F = true;
        break;
      }
      messageComponents.push(
        <div style={{ width: "100%" }}>
          {item.uiCommand === "A3" && (
            <>
             <MessageA3 item={item} index={index} />   
            </>
          )}
             {item.uiCommand === "A3SeeMore" && (
            <>
             <MessageA3SeeMore item={item} index={index} />   
            </>
          )}
          {/* {item.uiCommand === "A20V" && (
              <VideoMessage item={item} index={index} />
          )} */}
           {item.uiCommand === "A23A" && (
              <MessageA23A item={JSON.parse(item.data)} />
          )}
           {/* {item.uiCommand === "A23B" && (
              <MessageA23B item={item} index={index} />
          )} */}

          {item.uiCommand === "A4" && (
            <MessageA4
              item={item}
              handleClick={handleClick}
              setTextOnClick={setTextOnClick}
            />
          )}
            {item.uiCommand === "A14auto" && (
            <MessageA13s item={item} inputValue={inputValue} />
          )}


          {item.uiCommand === "A7" && (
            <div
              style={{
                display: "flex",
                width: "100%",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <MessageA7 item={item} setTextOnClick={setTextOnClick} TickIcon={TickIcon}/>
            </div>
          )}

          {item.uiCommand === "A13s" && (
            <MessageA13s item={item} inputValue={inputValue} />
          )}


          {/* {item.uiCommand === "Redirect" && (
            <MessageRedirect
              item={item}
              handleClick={handleClick}
              setTextOnClick={setTextOnClick}
              redirectClick={redirectClick}
            />
          )} */}

          {/* {item.uiCommand === "A14auto" && (
            <MessageA13s item={item} inputValue={inputValue} />
          )} */}

          
          {item.uiCommand === "A13" && (
            <MessageA13 item={item} inputValue={inputValue} />
          )}

          {item.uiCommand === "A14" && (
            <MessageA14 item={item} inputValue={inputValue} />
          )}
          {item.uiCommand === "A14c" && (
            <MessageA14C item={item} inputValue={inputValue} />
          )}
          {item.uiCommand === "A14s" && (
            <MessageA14s item={item} inputValue={inputValue} setCodevalue ={setCodeValue}/>
          )}

          {item.uiCommand === "A81" && (
            <MessageA81
              item={item}
              setLitmusFeedback={setLitmusFeedback}
              inputValue={inputValue}
              disableButtons ={disableButtons }
            />
          )}

  
      
          {item.uiCommand === "A15" && (
            <MessageA15
              item={item}
              handleClick={handleClick}
              setTextOnClick={setTextOnClick}
              disabled={true}
              inputValue={inputValue}
            />
          )}

          {item.uiCommand === "A19" && <MessageA19 item={item} />}
          {item.uiCommand === "A20" && <MessageA20 item={item} />}
          {/* {item.uiCommand === "A21" && (
            <MessageA21
              item={item}
              handleClick={handleClick}
              setTextOnClick={setTextOnClick}
              inputValue={inputValue}
              setShowErrorPopUp={setShowErrorPopUp}
              showErrorPopUp={showErrorPopUp}
              {...props}
            />
          )} */}

          {item.uiCommand === "A22" && (
            <MessageA22
              item={item}
              handleClick={handleClick}
              setTextOnClick={setTextOnClick}
              inputValue={inputValue}
            />
          )}

          {item.uiCommand === "A23" && (
            <div  key= {index} style={{float : 'left' ,margin : '0px 10px'}} className="A23-container">
              <MessageA23
                item={item}
                handleClick={handleClick}
                setTextOnClick={setTextOnClick}
                inputValue={inputValue}
              />
            </div>
          )}

          {item.uiCommand === "A3S" && (
             <MessageA3s item={item.text}/>
          )}

          {item.uiCommand === "A24" && (
            <MessageA24
              item={item}
              inputValue={inputValue}
            />
          )}

          {item.uiCommand === "A1i" && (
            <MessageA1i
            item={item}
            handleClick={handleClick}
            setTextOnClick={setTextOnClick}
            />
          )}

          {/* {item.uiCommand === "A1IMG" && (
            <A1IMG
            item={item}
            handleClick={handleClick}
            setTextOnClick={setTextOnClick}
            />
          )} */}
          {item.uiCommand === "A1DeviceSwitch" && (
            <A1DeviceSwitch
            item={item}
            handleClick={handleClick}
            setTextOnClick={setTextOnClick}
            inputValue={inputValue} 
            />
          )}
        






        
          {item.uiCommand === "WC26TABLE" && (
            <WC26TABLE
            item={item}
            handleClick={handleClick}
            setTextOnClick={setTextOnClick}
            inputValue={inputValue} 
            />
          )}

          {item.uiCommand === "A5" && (
            <>
             <CustomDatePicker item={item} inputValue={inputValue} />   
            </>
          )}

          {item.uiCommand === "A1e" &&
            secureLocalStorage.setItem("specialCode", item.code)}



          {item.uiCommand === "A1DeviceLimit" && (
            <A1DeviceLimit item={item} />
          )}
          {item.uiCommand === "A1DeviceLimitList" && (
            <A1DeviceLimitList item={item} />

          )}
        </div>
      );
    }

    return messageComponents;
  };
  useEffect(() => {
    function splitByA1Break(data) {
      const segments = [];
      let currentSegment = [];
  
      data.forEach((item) => {
        if (item.uiCommand === "A1break") {
          if (currentSegment.length > 0) {
            segments.push(currentSegment);
            currentSegment = [];
          }
        } else {
          currentSegment.push(item);
        }
      });
  
      if (currentSegment.length > 0) {
        segments.push(currentSegment);
      }
  
      return segments;
    }
  
    let data;
    let dataObj = {};
  
    
    dataObj.isA3F = currentData?.some(item => item.uiCommand === "A3f");
  
    data =
      currentData &&
        currentData.length > 0 &&
        currentData[0]?.uiCommand !== "idle" ? (
        <>
          {splitByA1Break(currentData).map((group, groupIndex) => (
            <div
              key={groupIndex}
              style={{ marginTop: groupIndex !== 0 ? "16px" : "16px" }}
              className={
                props.mergeUI && textOnClick === undefined
                  ? group[0]?.uiCommand === "A7"
                    ? ""
                    : "mergeConversation"
                  : isTableResponse(group)
                  ? "no-wrap-table"
                  : "no-wrap"
              }
            >
              {messageContent(group, dataObj)}
  
              {!dataObj?.isA3F && (
                <div
                  className="A1-container"
                  style={{ display: props?.CTAView && 'flow' }}
                >
                  {group.map((item, index) => {
                    return (
                      <>
                        {item.uiCommand === "A1" && (
                          <MessageA1
                            item={item}
                            handleClick={handleClick}
                            setTextOnClick={setTextOnClick}
                            index={index}
                            setSubTextOnClick={setSubTextOnClick}
                            setGenesisUrl={setGenesisUrl}
                            setShowIframe={setShowIframe}
                            iframeRef={iframeRef}
                            setChatWithAgentClicked={setChatWithAgentClicked}
                          />
                        )}
                        {item.uiCommand === "A1live" && (
                          <MessageA1Live
                            item={item}
                            handleClick={handleClick}
                            setTextOnClick={setTextOnClick}
                            index={index}
                            setSubTextOnClick={setSubTextOnClick}
                            setGenesisUrl={setGenesisUrl}
                            setShowIframe={setShowIframe}
                            iframeRef={iframeRef}
                            setChatWithAgentClicked={setChatWithAgentClicked}
                            chatWithAgentClicked={chatWithAgentClicked}
                          />
                        )}
                        {item.uiCommand === "A21i" && (
                          <MessageA21
                            item={item}
                            handleClick={handleClick}
                            setTextOnClick={setTextOnClick}
                            index={index}
                            setSubTextOnClick={setSubTextOnClick}
                            setEnableAttachment={setEnableAttachment}
                            setAttachementImg={setAttachementImg}
                            {...props}
                          />
                        )}
                          {item.uiCommand === "Redirect" && (
                          <MessageRedirect
                            item={item}
                            handleClick={handleClick}
                            setTextOnClick={setTextOnClick}
                            redirectClick={redirectClick}
                          />
                        )}
                      </>
                    );
                  })}
                </div>
              )}
  
              <div style={{ marginLeft: "2%" }}>
                {group.length > 0 && group[0].uiCommand !== "A7" && (
                  <div className="delivery-time-first">
                    {timeCurrent}
                    <span style={{ marginLeft: '4px', marginTop: '4px' }}>
                      <img src={TickIcon} alt="tick" />
                    </span>
                  </div>
                )}
              </div>
            </div>
          ))}
  
          {dataObj?.isA3F && (
            <div style={{ display: "flex" }}>
              <div
                className={
                  props.mergeUI && textOnClick === undefined
                    ? `clickWrap`
                    : "no-wrap"
                }
              >
                {currentData.map((item, index) => {
                  return (
                    <div style={{ width: "100%" }} key={index}>
                      {item.uiCommand === "A3f" && (
                        <div className="A3-container">
                          <MessageA3F
                            item={item}
                            handleClick={handleClick}
                            setTextOnClick={setTextOnClick}
                          />
                        </div>
                      )}
                    </div>
                  );
                })}
                <div
                  style={{ marginBottom: "10px", gap: "12px" }}
                  className="A23-container"
                >
                  {currentData?.map((item, index) => {
                    if (item?.text === "Thumbs Up") {
                      setFeedBackIndex((prevIndex) => prevIndex + 1);
                    }
                    return (
                      <>
                        {item.uiCommand === "A23" && (
                          <div key={index} className="A23-container">
                            <MessageA23
                              item={item}
                              handleClick={handleClick}
                              setTextOnClick={setTextOnClick}
                              inputValue={inputValue}
                              index={feedBackIndex}
                            />
                          </div>
                        )}
                      </>
                    );
                  })}
                </div>
  
                <div
                  className="A1-container"
                  style={{ display: props?.CTAView  && 'flow' }}
                >
                  {currentData.map((item, index) => {
                    return (
                      <>
                        {item.uiCommand === "A1" && (
                          <>
                            <MessageA1
                              item={item}
                              handleClick={handleClick}
                              setTextOnClick={setTextOnClick}
                              setSubTextOnClick={setSubTextOnClick}
                              setGenesisUrl={setGenesisUrl}
                              setShowIframe={setShowIframe}
                              iframeRef={iframeRef}
                              setChatWithAgentClicked={setChatWithAgentClicked}
                            />
                          </>
                        )}
                        {item.uiCommand === "A1live" && (
                          <>
                            <MessageA1Live
                              item={item}
                              handleClick={handleClick}
                              setTextOnClick={setTextOnClick}
                              setSubTextOnClick={setSubTextOnClick}
                              setGenesisUrl={setGenesisUrl}
                              setShowIframe={setShowIframe}
                              iframeRef={iframeRef}
                              setChatWithAgentClicked={setChatWithAgentClicked}
                              chatWithAgentClicked={chatWithAgentClicked}
                            />
                          </>
                        )}
                        {item.uiCommand === "A13s" && (
                          <MessageA13s item={item} inputValue={inputValue} />
                        )}
                        {item.uiCommand === "A15" && (
                          <MessageA15
                            item={item}
                            handleClick={handleClick}
                            setTextOnClick={setTextOnClick}
                            disabled={true}
                            inputValue={inputValue}
                          />
                        )}
                          {item.uiCommand === "Redirect" && (
                          <MessageRedirect
                            item={item}
                            handleClick={handleClick}
                            setTextOnClick={setTextOnClick}
                            redirectClick={redirectClick}
                          />
                        )}
                      </>
                    );
                  })}
                </div>
                <div style={{ marginLeft: "2%" }}>
                  {currentData.length > 0 &&
                    currentData[0].uiCommand !== "A7" && (
                      <div className="delivery-time-first">{timeCurrent}
                        <span style={{ marginLeft: '4px', display: 'flex', alignItems: 'center' }}>
                          <img src={TickIcon} alt="tick" />
                        </span>
                      </div>
                    )}
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        currentData &&
        !finalTimerFlag &&
        currentData.map((item, index) => {
          return (
            <div style={{ width: "100%", display: "flex" }} key={index}>
              {item.uiCommand === "idle" && (
                <div className="idle-wrap">
                  <p className="idle-wrap-text volte-text" style={{ margin: 0 }}>
                    {item.text}
                  </p>
                  <div style={{ fontSize: 10, color: "#abaeb2", marginTop: 4 }}>
                    {timeCurrent}
                  </div>
                </div>
              )}
            </div>
          );
        })
      );
      
      if (disableButtons) {
        DisableUI(selectionArray);
      
        setCodeValue(null)
        selectionArray.forEach(item => {
          if (item.selection === "null") return; 
      

          const parentDiv = document.getElementsByClassName(`${item.index}`)[0];
          if (!parentDiv) return; 
      
          
          const tabs = parentDiv.getElementsByClassName("action-tab");
      
        
          for (let tab of tabs) {
            const text = tab.textContent.trim();
             console.log(text)
            if (text === item.selection) {
              if(text === "Submit"){
                tab.classList.remove("chat-label-select");
                tab.classList.remove("submit-btn")
                tab.classList.add("submit-btn:disabled")
              }
              tab.classList.remove("chat-label");
              tab.classList.add("chat-label-select");
              break;
            }
          }
        });
      
        setDisableButtons(false);
      }
      
      



    if (data) {
      setMessages([...messages, data]);
    }
  }, [currentData]);
  
  

  return (
    <div className="container">
      {props.thirdOkay && (
        <div className="chat-box-wrapper">
          <div class="coach-screen-inner"></div>
        </div>
      )}
      {props.loginLoader ? (
        <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      ) : (
        <>
          {initialLoading && !props.historyLoader && (
            <div class="spinner">
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
          )}
          {showHistory && props.sth && (
            <>
              {" "}
              {props.historyLoader ? (
                <div class="spinner">
                  <div class="bounce1"></div>
                  <div class="bounce2"></div>
                  <div class="bounce3"></div>
                </div>
              ) : (
                <div> {historyData}</div>
              )}
            </>
          )}
          <div style={{marginTop : '10px'}} className={props.mergeUI ? "mergeUI-chat-icon-flex" : "block"}>
         
                <img
                  style={{ height: "40px" }}
                  src="https://help.tataplay.com/uploads/templateimages/logo.c1bb6180.png"
                  alt=""
                />
   

              <img
                src="data:image/png;base64,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"
                alt="Buddy"
                style={{ paddingLeft: "10px" }}
              ></img>
              <div className="welcome-message">Our Virtual Assitant is here to assist you</div>
              {/* <div className="welcome-message-sub">This chat is 100% free and I’m recording it as per our Privacy Policy</div> */}
            {messages}
          </div>
          {props.isLoading && (
            <div class="spinner">
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
          )}
          
      {showDelayLoader && (
        <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      )}
        </>
        
      )}
      <div ref={messagesEndRef} style={{ height: "10px" }} />
    </div>
  );
};

export default Conversation;
